import { useQuery } from "@tanstack/react-query";
import { getDamLevels, type Coordinates } from "@services/zenith/damLevels";

/** Seqwater's dams nearest a point, refreshed every 10 minutes while the page is visible; idle without a point. */
export const useGetDamLevels = (near?: Coordinates) => {
  return useQuery({
    queryKey: ["damLevels", near],
    queryFn: () => getDamLevels(near),
    enabled: Boolean(near),
    refetchInterval: 10 * 60_000,
    // The API already falls back on its last good levels, and repeats a failure for a minute before it reads Seqwater
    // again: a retry would only get the same 502.
    retry: false,
    // The card says dam levels are unavailable; an outage must not take the dashboard down with it.
    useErrorBoundary: false,
  });
};
